export function authHeader() {
  // return authorization header with jwt token
  const jwtToken = JSON.parse(sessionStorage.getItem("jwtToken"));
  if (jwtToken) {
    return { Authorization: "Bearer " + jwtToken };
  } else {
    return {};
  }
}

export function refreshToken() {
  // return authorization header with jwt token
  const deviceToken = JSON.parse(sessionStorage.getItem("refreshToken"));

  if (deviceToken) {
    return { refreshToken: deviceToken };
  } else {
    return {};
  }
}
